<template>
  <div
    class="flex min-h-screen flex-col items-center justify-center bg-surface-base px-4"
  >
    <div class="mb-8 text-center">
      <BrandLogo :size="56" class="mx-auto shadow-sm" />
      <h1 class="mt-3 text-xl font-semibold text-ink-gray-9">Glamora</h1>
      <p class="mt-1 text-sm text-ink-gray-5">Salon management workspace</p>
    </div>
    <div class="w-full max-w-md">
      <slot />
    </div>
  </div>
</template>

<script setup>
import BrandLogo from '../components/BrandLogo.vue'
</script>
